import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type OverlayBlockerData = {
  message?: string;
  description?: string;
  spinnerSize?: 'sm' | 'md' | 'lg';
};

@Component({
  selector: 'app-overlay-blocker',
  standalone: false,
  templateUrl: './overlay-blocker.component.html',
  styleUrls: ['./overlay-blocker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayBlockerComponent {
  private readonly dialogData = inject<OverlayBlockerData | null>(
    MAT_DIALOG_DATA,
    {
      optional: true
    }
  );

  /**
   * Optional message to display below the spinner
   */
  message = input<string>(this.dialogData?.message || '');

  /**
   * Optional description to display below the message
   */
  description = input<string>(this.dialogData?.description || '');

  /**
   * Size of the spinner (default: 'lg')
   */
  spinnerSize = input<'sm' | 'md' | 'lg'>(this.dialogData?.spinnerSize || 'lg');
}
